import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography, Alert, LinearProgress } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import client from '../../client';
import Navbar from '../../components/Navbar';
import slugify from '../../utils/slugify';

const Batch = () => {
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [core, setCore] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [submissionErrors, setSubmissionErrors] = useState([]);
  const [password, setPassword] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handlePasswordSubmit = (event) => {
    event.preventDefault();
    if (password === '290304') {
      setShowForm(true);
      setError('');
    } else {
      setError('Senha incorreta.');
      setShowForm(false);
    }
  };

  const handleFolderChange = (event) => {
    const files = event.target.files;
    console.log("Arquivos selecionados (handleFolderChange):", files);
    const fileArray = Array.from(files);
    setSelectedFolder(fileArray);
    setSubmissionErrors([]);
    setUploadProgress({});
  };

  const uploadAsset = async (file, assetType) => {
    if (!file) return null;
    try {
      const uploadedAsset = await client.assets.upload(assetType, file, {
        contentType: file.type,
        filename: file.name,
      });
      console.log(`Asset ${file.name} (${assetType}) uploaded:`, uploadedAsset);
      return { _type: 'reference', _ref: uploadedAsset._id };
    } catch (error) {
      console.error(`Erro ao fazer upload de ${file.name} (${assetType}):`, error);
      return null;
    }
  };

  const findImage = (folderNameHint, baseName) => {
    const possibleExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.webp'];
    const targetFolderName = folderNameHint.toLowerCase();
    const expectedBase = baseName.toLowerCase();

    for (let i = 0; i < selectedFolder.length; i++) {
      const file = selectedFolder[i];

      if (file.webkitRelativePath) {
        const relativePathLower = file.webkitRelativePath.toLowerCase();
        if (relativePathLower.includes(targetFolderName + '/')) {
          const fileNameWithExt = file.name.toLowerCase();
          const fileNameBase = fileNameWithExt.split('.')[0];
          const fileExtension = fileNameWithExt.split('.').pop();

          if (fileNameBase === expectedBase && possibleExtensions.includes(`.${fileExtension}`)) {
            return file;
          }
        }
      }
    }
    return null;
  };

  const findVideo = (folderNameHint, baseName) => {
    const possibleExtensions = ['.mp4', '.webm', '.ogg'];
    const targetFolderName = folderNameHint.toLowerCase();
    const expectedBase = baseName.toLowerCase();

    for (let i = 0; i < selectedFolder.length; i++) {
      const file = selectedFolder[i];

      if (file.webkitRelativePath) {
        const relativePathLower = file.webkitRelativePath.toLowerCase();
        if (relativePathLower.includes(targetFolderName + '/')) {
          const fileNameWithExt = file.name.toLowerCase();
          const fileNameBase = fileNameWithExt.split('.')[0];
          const fileExtension = fileNameWithExt.split('.').pop();

          if (fileNameBase === expectedBase && possibleExtensions.includes(`.${fileExtension}`)) {
            return file;
          }
        }
      }
    }
    return null;
  };

  const processAndUploadFile = async (file, coreValue) => {
    const filenameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.'));

    const boxFile = findImage('Named_Boxarts', filenameWithoutExtension);
    const logoFile = findImage('Named_Logos', filenameWithoutExtension);
    const snapFile = findImage('Named_Snaps', filenameWithoutExtension);
    const titleFile = findImage('Named_Titles', filenameWithoutExtension);
    const videoFile = findVideo('Named_Videos', filenameWithoutExtension);

    const boxAsset = await uploadAsset(boxFile, 'image');
    const logoAsset = await uploadAsset(logoFile, 'image');
    const snapAsset = await uploadAsset(snapFile, 'image');
    const titleAsset = await uploadAsset(titleFile, 'image');
    const videoAsset = await uploadAsset(videoFile, 'file');
    const gameFileAsset = await uploadAsset(file, 'file');

    if (gameFileAsset) {
      const doc = {
        _type: 'game',
        name: filenameWithoutExtension,
        core: coreValue,
        box: boxAsset ? { _type: 'image', asset: boxAsset } : undefined,
        logo: logoAsset ? { _type: 'image', asset: logoAsset } : undefined,
        snap: snapAsset ? { _type: 'image', asset: snapAsset } : undefined,
        title: titleAsset ? { _type: 'image', asset: titleAsset } : undefined,
        video: videoAsset ? { _type: 'file', asset: videoAsset } : undefined,
        file: gameFileAsset ? { _type: 'file', asset: gameFileAsset } : undefined,
        slug: {
          _type: 'slug',
          current: slugify(filenameWithoutExtension),
        },
      };

      try {
        const createdDocument = await client.create(doc);
        console.log(`Jogo "${filenameWithoutExtension}" adicionado com sucesso! ID:`, createdDocument._id);
        return { success: true, name: filenameWithoutExtension };
      } catch (error) {
        console.error(`Erro ao adicionar o jogo "${filenameWithoutExtension}":`, error);
        return { success: false, name: filenameWithoutExtension, error: error.message };
      }
    } else {
      return { success: false, name: filenameWithoutExtension, error: 'Erro ao fazer upload do arquivo ROM.' };
    }
  };

  const handleBatchSubmit = async (event) => {
    event.preventDefault();
    if (!selectedFolder || selectedFolder.length === 0) {
      alert('Por favor, selecione a pasta contendo os arquivos.');
      return;
    }
    if (!core) {
      alert('Por favor, selecione o core.');
      return;
    }

    setIsSubmitting(true);
    const filesToUpload = selectedFolder.filter(
      (file) => file.name.includes('.') && (!file.webkitRelativePath || !file.webkitRelativePath.toLowerCase().includes('named_'))
    );
    const totalFiles = filesToUpload.length;
    console.log("Arquivos identificados para upload:", filesToUpload.map(f => f.name)); // ADICIONE ESTE LOG
    const progress = {};
    filesToUpload.forEach(file => {
      progress[file.name] = 0;
    });
    setUploadProgress(progress);
    setSubmissionErrors([]);

    const batchSize = 1; // Defina o tamanho do lote
    const delayBetweenBatches = 5000; // Milissegundos (5 segundos)

    for (let i = 0; i < totalFiles; i += batchSize) {
      const batch = filesToUpload.slice(i, i + batchSize);
      const results = await Promise.all(
        batch.map(async (file) => {
          console.log(`Iniciando processamento de: ${file.name}`); // ADICIONE ESTE LOG
          const result = await processAndUploadFile(file, core);
          setUploadProgress(prevProgress => {
            return {
              ...prevProgress,
              [file.name]: 100,
            };
          });
          console.log(`Resultado do processamento de ${file.name}:`, result); // ADICIONE ESTE LOG
          return result;
        })
      );

      const errorsInBatch = results.filter(res => !res.success);
      setSubmissionErrors(prevErrors => [...prevErrors, ...errorsInBatch]);

      if (i + batchSize < totalFiles) {
        console.log(`Aguardando ${delayBetweenBatches}ms antes do próximo lote...`);
        await new Promise(resolve => setTimeout(resolve, delayBetweenBatches));
      }
    }

    setIsSubmitting(false);
    const finalErrors = submissionErrors; // Use o acumulado de erros
    const successfulUploads = totalFiles - finalErrors.length;

    if (finalErrors.length === 0) {
      alert(`Todos os ${totalFiles} jogos foram adicionados com sucesso!`);
      navigate(`/${core}`);
    } else {
      alert(`${successfulUploads} de ${totalFiles} jogos foram adicionados. Verifique a lista de erros.`);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          px: 2,
          pb: '96px',
        }}
      >
        {!showForm ? (
          <form onSubmit={handlePasswordSubmit} noValidate style={{ width: '100%', maxWidth: 256 }}>
            <TextField
              placeholder="Senha"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              required
              sx={{
                mt: '0!important'
              }}
            />
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Entrar
            </Button>
            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          </form>
        ) : (
          <>
            <Typography variant="h4" component="h2" gutterBottom>
              Adicionar em Lote
            </Typography>

            <form onSubmit={handleBatchSubmit} style={{ width: '100%', maxWidth: 400 }}>
              <TextField
                label="Core"
                fullWidth
                margin="normal"
                value={core}
                onChange={(e) => setCore(e.target.value)}
                required
                autoFocus
              />
              <Box sx={{ mt: 2 }}>
                <label htmlFor="folder-upload">
                  <input
                    style={{ display: 'none' }}
                    id="folder-upload"
                    type="file"
                    multiple
                    webkitdirectory="true" // Correção do atributo
                    onChange={handleFolderChange}
                  />
                  <Button
                    variant="outlined"
                    component="span"
                    fullWidth
                    startIcon={<ImageIcon />}
                  >
                    {selectedFolder ? `Pasta Selecionada (${selectedFolder.length} arquivos)` : 'Selecionar Pasta de Jogos'}
                  </Button>
                </label>
              </Box>

              {isSubmitting && (
                <Box sx={{ width: '100%', mt: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Processando e enviando arquivos...
                  </Typography>
                  {Object.keys(uploadProgress).map((filename) => (
                    <Box key={filename} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Typography variant="caption" sx={{ width: 120, mr: 1, textAlign: 'left' }}>
                        {filename}
                      </Typography>
                      <LinearProgress variant="determinate" value={uploadProgress[filename] || 0} sx={{ flexGrow: 1, mr: 1 }} />
                      <Typography variant="caption">{uploadProgress[filename] || 0}%</Typography>
                    </Box>
                  ))}
                </Box>
              )}

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 3 }}
                disabled={isSubmitting || !selectedFolder}
              >
                {isSubmitting ? 'Adicionando Lote...' : 'Adicionar Lote'}
              </Button>

              {submissionErrors.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography color="error">Erros ao adicionar alguns jogos:</Typography>
                  <ul>
                    {submissionErrors.map((errorObj, index) => (
                      <li key={index}>
                        {errorObj.name}: {errorObj.error}
                      </li>
                    ))}
                  </ul>
                </Box>
              )}
            </form>
          </>
        )}
      </Box>
      <Navbar />
    </>
  );
};

export default Batch;